export const filterOptionsByLabel = (input, option) => (option?.label ? String(option?.label) : '').toLowerCase().includes(input.toLowerCase());